import {
  REMOVE_WALK
} from '../constants/index'

export const removeWalk = (payload: any) => {
  return {
    type: REMOVE_WALK,
    payload
  }
}

export const removeMyWalk = (id: number) => (dispatch: any) => {
  // console.log('getting walks')
  dispatch(removeWalk(id))
}